export default {
  root: ({ attrs }) => ({
    class: [
      'relative',

      // Flexbox & Alignment
      'inline-flex',
      'align-bottom',

      // Size
      { 'w-5 h-5': !attrs['size'], 'w-4 h-4': attrs['size'] === 'small' },

      // Misc
      'cursor-pointer',
      'select-none'
    ]
  }),
  box: ({ props, attrs }) => ({
    class: [
      // Flexbox
      'flex justify-center items-center',

      // Size
      { 'w-5 h-5': !attrs['size'], 'w-4 h-4': attrs['size'] === 'small' },

      // Shape
      'border-2',
      'rounded-full',

      // Transition
      'transition duration-200 ease-in-out',

      // Colors
      {
        'text-surface-700 dark:text-white/80':
          props.value !== props.modelValue && props.value !== undefined,
        'border-gray-700 dark:border-surface-700':
          props.value !== props.modelValue && props.value !== undefined && !props.invalid,
        'border-primary-400':
          props.value == props.modelValue &&
          props.value !== undefined &&
          !props.disabled &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'border-purple-300':
          props.value == props.modelValue &&
          props.value !== undefined &&
          !props.disabled &&
          attrs['gbTheme'] === 'purple',
        'border-gray-600':
          props.value == props.modelValue && props.value !== undefined && props.disabled
      },
      // Invalid State
      { 'border-red-300 dark:border-red-400': props.invalid },

      // States
      {
        'peer-hover:border-gray-1000 dark:peer-hover:border-primary':
          !props.disabled && !props.invalid,
        'peer-hover:border-primary-500':
          !props.disabled &&
          props.value == props.modelValue &&
          props.value !== undefined &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'peer-hover:border-purple-400':
          !props.disabled &&
          props.value == props.modelValue &&
          props.value !== undefined &&
          attrs['gbTheme'] === 'purple',
        'peer-focus-visible:outline-none peer-focus-visible:outline-offset peer-focus-visible:ring  peer-focus-visible:ring-offset-2 peer-focus-visible:border-gray-1000':
          !props.disabled,
        'peer-focus-visible:ring-primary-500':
          !props.disabled &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'peer-focus-visible:ring-purple-400': !props.disabled && attrs['gbTheme'] === 'purple',
        'cursor-not-allowed bg-gray-300 border-gray-600': props.disabled
      }
    ]
  }),
  input: ({ props }) => ({
    class: [
      'peer',

      // Size
      'w-full ',
      'h-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded-md',
      'outline-none',
      'border-2 border-gray-700 dark:border-surface-700',

      // Misc
      'appearance-none',
      { 'cursor-pointer': !props.disabled }
    ]
  }),
  icon: ({ props, attrs }) => ({
    class: [
      'block',

      // Shape
      'rounded-full',

      // Size
      { 'w-2.5 h-2.5': !attrs['size'], 'w-2 h-2': attrs['size'] === 'small' },

      // Colors
      {
        'bg-primary-400 peer-hover:bg-primary-500 peer-focus-visible:bg-primary-500':
          props.value == props.modelValue &&
          props.value !== undefined &&
          !props.disabled &&
          (attrs['gbTheme'] === 'primary' ||
            attrs['gbTheme'] === 'blue' ||
            attrs['gbTheme'] === undefined),
        'bg-purple-300 peer-hover:bg-purple-400 peer-focus-visible:bg-purple-400':
          props.value == props.modelValue &&
          props.value !== undefined &&
          !props.disabled &&
          attrs['gbTheme'] === 'purple',
        'bg-gray-600':
          props.value == props.modelValue && props.value !== undefined && props.disabled
      },

      // Conditions
      {
        'backface-hidden scale-10 invisible': props.value !== props.modelValue,
        'transform visible scale-100': props.value == props.modelValue
      },

      // Transition
      'transition duration-200'
    ]
  })
}
